import { useTranslation } from 'react-i18next';
import CardCenteredContent from '../core/card/CardCenteredContent';
import Button from '../core/button/CoreButton';
import ActivateLicenseDialog from './ActivateLicenseDialog';
import { useState } from 'react';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';

interface IActivateLicenseCardCenteredContentProps {
    organizationId?: string;
}

export default function ActivateLicenseCardCenteredContent({
    organizationId,
}: IActivateLicenseCardCenteredContentProps) {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);
    const currentUserContainer = CurrentUserContainer.useContainer();

    const onDialogCancel = () => {
        setShowDialog(false);
    };

    if (!currentUserContainer.currentUser?.isEmailVerified) {
        return null;
    }

    const description = organizationId
        ? t('common:license.activate.description')
        : t('common:license.activate.descriptionLong');

    return (
        <>
            <CardCenteredContent
                title={t('common:license.activate.title')}
                description={description}
                name="orgAuthClient">
                <Button $color="secondary" startIcon="plusLight" onClick={() => setShowDialog(true)}>
                    {t('common:license.activate.button')}
                </Button>
            </CardCenteredContent>
            <ActivateLicenseDialog open={showDialog} onCancel={onDialogCancel} organizationId={organizationId} />
        </>
    );
}
